<script setup>
  const emit = defineEmits(['update:modelValue']);

  const props = defineProps({
    name: {
      type: String,
      default: '',
    },
    modelValue: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'purple',
    },
    onChange: {
      type: Function,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    halfMarked: {
      type: Boolean,
      default: false,
    },
    // The visible caption lives in the caller, so it names the box here.
    ariaLabel: String,
  });

  function handleChange(e) {
    emit('update:modelValue', e.target.checked);
    props.onChange?.(e);
  }
</script>

<template>
  <div class="pge-checkbox-main">
    <label :aria-label="props.ariaLabel || undefined">
      <input 
        type="checkbox" 
        :class="props.halfMarked ? 'half-marked' : ''"
        :id="props.name" 
        :aria-label="props.ariaLabel || undefined"
        :disabled="props.disabled" 
        :name="props.name" 
        :checked="props.modelValue" 
        @change="handleChange"
      />
      <div :class="'pge-checkbox pge-checkbox-' + props.variant">
        <div class="state-layer">
          <div class="pge-container">
            <span class="icon"></span>
          </div>
          <div class="ripple"></div>
        </div>
      </div>
    </label>
  </div>
</template>

<style>
@import url('./styles/pge-checkbox/index.css');
@import url("./styles/pge-checkbox/purple/checked.css");
@import url("./styles/pge-checkbox/purple/half-marked.css");
@import url("./styles/pge-checkbox/purple/unchecked.css");

@import url("./styles/pge-checkbox/error/checked.css");
@import url("./styles/pge-checkbox/error/half-marked.css");
@import url("./styles/pge-checkbox/error/unchecked.css");
</style>